export const DB_URL='http://localhost:5000'
